import { createContext } from 'react';
import RootStore from 'stores/RootStore'
const StoresContext = createContext<typeof RootStore>({} as typeof RootStore)
export default StoresContext